/* eslint-disable no-console */
import config from '../../package.json';

export function showVersion() {
  const status = process.env.REACT_APP_BUILD_STATUS;
  const excludeStatus = ['PRODUCTION', 'STAGING'];

  console.group('App info:');

  let version = config.version;
  if (status === undefined) {
    version = 'NOT FOR TESTING';
  }

  if (!excludeStatus.includes(status ?? '')) {
    const label = document.createElement('span');
    label.innerText = version;
    label.classList.add('version');

    if (status === undefined) {
      label.classList.add('version__highlight');
    }
    document.body.appendChild(label);
  }

  console.log('Build version: ' + version);

  console.groupEnd();
}
